import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Input,
  Stack,
  IconButton,
  Form,
  Message,
  Table,
  toaster,
  InputNumber
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useTableHeight from '@/components/useTableHeight';
import { attempt } from 'lodash';

interface RowDataRate {
  id: string; // or number, depending on your data
  attributes: {
    exchangerate: number;
    currencyname: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const CurrencyMaster = () => {
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();
  
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [currencyD, setCurrencyD] = useState([]);
  const [editedRowIdsRate, setEditedRowIdsRate] = useState<string[]>([]);
  const [editedRowIdRate, setEditedRowIdRate] = useState<string>('');
  const [editedDataRate, setEditedDataRate] = useState<
    Record<string, Partial<RowDataRate['attributes']>>
  >({});
  const [currencyFormData, setCurrencyFormData] = useState({
    currencyname: '',
    exchangerate: 0
  });

  useEffect(() => {
    fetchDataCur();
  }, []);
  const fetchDataCur = async () => {
    try {
      const response = await fetch(
        `${globalIP}/api/currency-masters?populate=*&pagination[page]=1&sort[0]=id`
      );
      const json = await response.json();
      // const extractedData = json.data[0].attributes;
      setCurrencyD(json.data || []);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const processInputRef = useRef(null);
  const handleEditRowRate = rowData => {
    setCurrencyFormData({ ...rowData.attributes });
    setEditedRowIdRate(rowData.id)
    setEditedRowIdsRate(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDataRate(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));

    if (processInputRef.current) {
      processInputRef.current.focus();
    }
  };
  const resetCurrency = () => {
    setCurrencyFormData({
      currencyname: '',
      exchangerate: 0
    });
  };
  const handleCancelCurrency = rowData => {
    resetCurrency();
    setEditedRowIdRate('');
    setEditedRowIdsRate('');
  };
  const submitcurrency = async () => {
    const normalizedCurrencyName = currencyFormData.currencyname?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/

    if (!normalizedCurrencyName) {
      toaster.push(
        <Message showIcon type="warning">
          Please Enter Currency name.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (specialCharPattern.test(normalizedCurrencyName)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.currencyname} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }

    try {
      const { data: currency } = await axios.get(
        `${globalIP}/api/currency-masters?populate=*&filters[currencyname][$eqi]=${normalizedCurrencyName}`
      );

      if (currency.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.currencyname} {normalizedCurrencyName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // Ensure trimmed currency name is used in the payload
      const payload = {
        data: { ...currencyFormData, currencyname: normalizedCurrencyName }
      };

      const response = await fetch(`${globalIP}/api/currency-masters`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        await fetchDataCur();

        toaster.push(
          <Message showIcon type="success">
            Data is Saved.
          </Message>,
          { placement: 'topEnd' }
        );
      } else {
        console.error('Failed to save data:', await response.text());
      }
    } catch (error) {
      console.error('Error in submit:', error);
    }

    // Reset the form
    setCurrencyFormData({
      currencyname: '',
      exchangerate: 0
    });
  };

  const handleInputChangeC = (inputName, value, defaultValue) => {
    setCurrencyFormData({
      ...currencyFormData,
      ...(value ? { [inputName]: value } : { [inputName]: defaultValue })
    });
  };

  const handleDelete = async (id: number | undefined) => {
    if (id !== undefined) {
      try {
        const response = await fetch(`${globalIP}/api/currency-masters/${id}`, {
          method: 'DELETE'
        });

        if (response.ok) {
          setCurrencyD(currencyD.filter(item => item.id !== id));
          toaster.push(
            <Message showIcon type="success">
              Currency deleted successfully.
            </Message>,
            { placement: 'topEnd' }
          );
        } else {
          console.error('Failed to delete data:', await response.text());
          toaster.push(
            <Message showIcon type="error">
              Failed to delete currency.
            </Message>,
            { placement: 'topEnd' }
          );
        }
      } catch (error) {
        console.error('Error in handleDelete:', error);
      }
    }
  };
  const handleSaveRowrate = async () => {
    try {
      // const rowData = currencyD.find(row => row.id === rowId);
      if (!currencyFormData) {
        console.error('Row data not found.');
        return;
      }
      const updatedCategoryName = currencyFormData?.exchangerate;
      const updatedcurrencyname = currencyFormData?.currencyname?.trim() || '';
      // const updatedCategoryName1 = editedDataRate[rowId]?.exchangerate;
      // const updatedcurrencyname1 = editedDataRate[rowId]?.currencyname?.trim();
      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/

      // Check if currency name exists in the database excluding current rowId
     

      if (!updatedcurrencyname) {
        toaster.push(
          <Message showIcon type="error">
            Please enter Currency Name.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      if (specialCharPattern.test(updatedcurrencyname)) {
        toaster.push(
          <Message showIcon type="error">
            Currency Name should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      const { data: updatecurrency } = await axios.get(
        `${globalIP}/api/currency-masters?populate=*&filters[currencyname][$eqi]=${updatedcurrencyname}&filters[id][$ne]=${editedRowIdRate}`
      );
      if (updatecurrency?.data?.length > 0) {
        toaster.push(
          <Message showIcon type="warning">
            Currency Name "{updatedcurrencyname}" already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // Create the updated row data
      // const updatedRowData: RowDataRate = {
      //   ...rowData,
      //   attributes: {
      //     ...rowData.attributes,
      //     ...editedDataRate[rowId],
      //     exchangerate: updatedCategoryName,
      //     currencyname: updatedcurrencyname
      //   }
      // };

      // Send the PUT request to update the season
      const response = await fetch(`${globalIP}/api/currency-masters/${editedRowIdRate}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: {...currencyFormData, currencyname: updatedcurrencyname , exchangerate: updatedCategoryName} })
      });

      if (response.ok) {
        fetchDataCur();
        resetCurrency('')
        setEditedRowIdRate('')
        setEditedDataRate(prevData => ({...prevData, [editedRowIdRate]:  { ...currencyFormData, currencyname: updatedcurrencyname , exchangerate: updatedCategoryName }, }));
        setEditedRowIdsRate(prevRowIds =>  [...new Set([...prevRowIds, editedRowIdRate])]);
        toaster.push(
          <Message showIcon type="success">
            Rate updated successfully.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        console.error('Failed to save data');
        toaster.push(
          <Message showIcon type="error">
            Failed to save Rate. Please try again.
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };
  const handleSaveRowrate1 = async (rowId: string) => {
    try {
      const rowData = currencyD.find(row => row.id === rowId);
      if (!rowData) {
        console.error('Row data not found.');
        return;
      }

      const updatedCategoryName = editedDataRate[rowId]?.exchangerate;
      const updatedcurrencyname = editedDataRate[rowId]?.currencyname?.trim();
      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/

      // Check if currency name exists in the database excluding current rowId
      const { data: updatecurrency } = await axios.get(
        `${globalIP}/api/currency-masters?populate=*&filters[currencyname][$eqi]=${updatedcurrencyname}&filters[id][$ne]=${rowId}`
      );

      if (!updatedcurrencyname) {
        toaster.push(
          <Message showIcon type="error">
            Please enter Currency Name.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      if (specialCharPattern.test(updatedcurrencyname)) {
        toaster.push(
          <Message showIcon type="error">
            Currency Name should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      if (updatecurrency?.data?.length > 0) {
        toaster.push(
          <Message showIcon type="warning">
            Currency Name "{updatedcurrencyname}" already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // Create the updated row data
      const updatedRowData: RowDataRate = {
        ...rowData,
        attributes: {
          ...rowData.attributes,
          ...editedDataRate[rowId],
          exchangerate: updatedCategoryName,
          currencyname: updatedcurrencyname
        }
      };

      // Send the PUT request to update the season
      const response = await fetch(`${globalIP}/api/currency-masters/${rowData.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: updatedRowData.attributes })
      });

      if (response.ok) {
        fetchDataCur();
        setEditedRowIdsRate(prevRowIds => prevRowIds.filter(id => id !== rowId));
        toaster.push(
          <Message showIcon type="success">
            Rate updated successfully.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        console.error('Failed to save data');
        toaster.push(
          <Message showIcon type="error">
            Failed to save Rate. Please try again.
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangeRate = (rowId, fieldName, value) => {
    setEditedDataRate(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...currencyD.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };

  return (
    <>
      <Stack justifyContent="space-between" style={{ marginBottom: '10px' }} className="mstr-panel">
        <Stack spacing={5} className="mstr-panel1">
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>{label[0]?.attributes?.Currency}</b>
            </Form.ControlLabel>
            <Input
              id="currencyname"
              name="currencyname"
              value={currencyFormData.currencyname}
              autoComplete="off"
              ref={processInputRef}
              onChange={value => handleInputChangeC('currencyname', value, '')}
            />
          </Stack>
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
            <b>{label[0]?.attributes?.CurRate}</b>
            </Form.ControlLabel>
            <Input
              id="exchangerate"
              name="exchangerate"
              type="number"
              value={currencyFormData.exchangerate}
              onChange={value => handleInputChangeC('exchangerate', value, 0)}
            />
          </Stack>
          {editedRowIdRate ? ( <Button
            appearance="primary"
            color="cyan"
            onClick={handleSaveRowrate}
            className="mstr-btn-setting1"
            style={{ marginTop: '15px' }}
          >
            Update
          </Button>
          ) : ( 
          <Button
            appearance="primary"
            color="cyan"
            onClick={submitcurrency}
            className="mstr-btn-setting1"
            style={{ marginTop: '15px' }}
          >
            Save
          </Button>
        )}
        
        </Stack>
      </Stack>
      <Table rowHeight={60} data={currencyD} height={tableHeight} rowKey="id" bordered cellBordered>
        <Table.Column width={130} flexGrow={1}>
          <Table.HeaderCell>
          <b>{label[0]?.attributes?.Currency}</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIdsRate.includes(rowData.id) ? (
              //   <Input
              //     value={editedDataRate[rowData.id]?.currencyname || ''}
              //     onChange={value => handleInputChangeRate(rowData.id, 'currencyname', value)}
              //   />
              // ) : (
                rowData.attributes.currencyname
              // )
            }
          </Table.Cell>
          {/* <Cell dataKey="attributes.currencyname" /> */}
        </Table.Column>
        <Table.Column width={200}>
          <Table.HeaderCell>
          <b>{label[0]?.attributes?.CurRate}</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIdsRate.includes(rowData.id) ? (
              //   <InputNumber
              //     step={null}
              //     value={editedDataRate[rowData.id]?.exchangerate || 0}
              //     onChange={value => handleInputChangeRate(rowData.id, 'exchangerate', value)}
              //   />
              // ) : (
                rowData.attributes.exchangerate
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={100} fixed="right">
          <Table.HeaderCell>
            <b>Action</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              editedRowIdsRate.includes(rowData.id) ? (
                <div>
                  {/* <IconButton
                    size="sm"
                    icon={<CheckIcon />}
                    active
                    onClick={() => handleSaveRowrate(rowData.id)}
                    style={{ marginRight: '10px' }}
                  /> */}
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    active
                    onClick={handleCancelCurrency}
                    // onClick={() =>
                    //   setEditedRowIdsRate(prevRowIds => prevRowIds.filter(id => id !== rowData.id))
                    // }
                  />
                </div>
              ) : (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowRate(rowData)}
                  />
                </div>
              )
            }
          </Table.Cell>
        </Table.Column>
      </Table>
    </>
  );
};

export default CurrencyMaster;
